import { useBaseStore } from '@roc/feature-app-core';
import {
  geReferralsRoutes,
  getReferralsRoutesConfig,
} from '../routes';

export const useReferralsRoutes = () => {
  const { globalStore } = useBaseStore();
  const { routeBasePath, routeBaseUrl } = globalStore;
  return {
    referralsRoutes: geReferralsRoutes(routeBasePath, routeBaseUrl),
    referralsRoutesConfig: getReferralsRoutesConfig(
      routeBasePath,
      routeBaseUrl
    ),
  };
};
